import { createSelector } from 'reselect';
import _ from 'lodash';

import { getSingleSingOnState } from './index';

export const getLoginState = createSelector(
  [getSingleSingOnState],
  loginState => _.get(loginState, 'loginEmail'),
);

export const getLoginEmailLoading = createSelector(
  [getLoginState],
  stateLogin => _.get(stateLogin, 'loading', false),
);

export const getError = createSelector(
  [getLoginState],
  stateLogin => _.get(stateLogin, 'error'),
);

export const getErrorLogIn = createSelector(
  [getError],
  errorLogIn => ({
    code: _.get(errorLogIn, 'code'),
    msg: _.get(errorLogIn, ['error', '0']),
  }),
);
